// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import 'react-datepicker/dist/react-datepicker.css';
import React, {PropTypes} from 'react';
import {
    getCorrectDateValue,
    transformDateValue
} from '../../../../shared/services/build-date';
import {FormattedMessage} from 'react-intl';
import StatusChange from '@deere/cps-it.warranty-model-factory/lib/status-change';
import WarrantyDatePicker from '../../../../shared/components/warranty-date-picker';

const handleStolenDateChange = props => newDate => props.onItemChange('stolenDate', getCorrectDateValue(newDate));

const StolenDate = props => {

    const status = props.statusChangeRequest.newStatus.key;

    return (
        <div className='labeled-string'>
            <span className='data-label'>
                {(status === 'STL1' || status === 'STLP') && <sup>{'*'}</sup>} <FormattedMessage id='STOLEN_DATE'/>
            </span>
            <div className={'date-picker'}>
                <WarrantyDatePicker
                    onChange={handleStolenDateChange(props)}
                    selected={transformDateValue(props.statusChangeRequest.lawEnforcementDetails.stolenDate)}
                />
            </div>
        </div>
    );

};

StolenDate.displayName = 'StolenDate';
StolenDate.propTypes = {
    onItemChange: PropTypes.func.isRequired,
    statusChangeRequest: PropTypes.instanceOf(StatusChange).isRequired
};

export default StolenDate;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/input-fields/stolen-date.js